module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/photoalbums/bravenet_photo_albums_easy_upload.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/photoalbums/bravenet_photo_albums_easy_upload.png
// module id = M3ou
// module chunks = 0